import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storageLimit: "",
  storageLimitExceeded: false,
  storageRemaining: "",
  storageUsed: "",
  storageUsedPercentage: "",
  audios: { data: [] },
  documents: { data: [] },
  images: { data: [] },
  wheels: { data: [] },
  videos: { data: [] },
  audiosStorage: "",
  documentsStorage: "",
  imagesStorage: "",
  wheelsStorage: "",
  videosStorage: "",
};

const storageSlice = createSlice({
  name: "hotbar",
  initialState,
  reducers: {
    setStorage: (state, action) => {
      const byType = action.payload.storage_by_type || {};
      state.storageLimit = action.payload.storage_limit;
      state.storageLimitExceeded = action.payload.storage_limit_exceeded;
      state.storageRemaining = action.payload.storage_remaining;
      state.storageUsed = action.payload.storage_used;
      state.storageUsedPercentage = action.payload.storage_used_percentage;
      // Each media type maps to its OWN by-type bucket. (Previously videos and
      // documents were both wired to `audios`, so the media-modal tab counts for
      // Videos/Documents wrongly showed the audio total.)
      state.audiosStorage = byType.audios;
      state.imagesStorage = byType.images;
      state.videosStorage = byType.videos;
      state.documentsStorage = byType.documents;
      state.wheelsStorage = byType.others;
    },
    setVideos: (state, action) => {
      state.videos = action.payload;
    },
    setImages: (state, action) => {
      state.images = action.payload;
    },
    setDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setAudios: (state, action) => {
      state.audios = action.payload;
    },
    setWheels: (state, action) => {
      state.wheels = action.payload;
    },
  },
});

export const { setStorage, setVideos, setImages, setDocuments, setAudios, setWheels } =
  storageSlice.actions;

export default storageSlice.reducer;
